import { api } from "./client";
import type { InventoryOverview } from "../types";

export interface UpgradeItemResult {
  success: boolean;
  message: string;
  success_rate: number;
  gold_spent: number;
  luck_level_used: number;
  inventory: InventoryOverview;
}

export const inventoryApi = {
  getOverview: () => api.get<InventoryOverview>("/inventory"),

  equip: (item_id: number) => api.post<InventoryOverview>("/inventory/equip", { item_id }),

  unequip: (slot: string) => api.post<InventoryOverview>(`/inventory/unequip/${slot}`),

  sell: (item_id: number) => api.post<InventoryOverview>("/inventory/sell", { item_id }),

  upgrade: (item_id: number, luck_level = 0) =>
    api.post<UpgradeItemResult>("/inventory/upgrade", { item_id, luck_level }),

  unlockSocket: (item_id: number) =>
    api.post<InventoryOverview>("/inventory/unlock-socket", { item_id }),

  socketGem: (item_id: number, socket_index: number, gem_type: string, gem_level: number) =>
    api.post<InventoryOverview>("/inventory/socket-gem", {
      item_id,
      socket_index,
      gem_type,
      gem_level,
    }),

  unsocketGem: (item_id: number, socket_index: number) =>
    api.post<InventoryOverview>("/inventory/unsocket-gem", { item_id, socket_index }),

  expand: () => api.post<InventoryOverview>("/inventory/expand"),
};
